import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { GetTagsSuccess } from '../actions/search-tags.actions';
import {
  BrandCodeChanged,
  ClearTagAssignmentOptions,
  TagAssignmentPanelStatusChanged,
  TagTypeChanged,
} from '../actions/tag-assignment.actions';
import { TagAssignmentState } from '../models/search-filters.model';

const initialState: TagAssignmentState = {
  panelExpanded: true,
  tagTypeValues: [],
  tagType: '',
  brandCode: '',
  searchAvailable: false,
};

export const TagAssignmentReducer = createReducer(
  initialState,
  on(TagAssignmentPanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(TagTypeChanged, (state, { tagType }) => ({
    ...state,
    tagType: tagType ?? '',
    searchAvailable: tagType ? true : false,
  })),
  on(BrandCodeChanged, (state, { brandCode }) => ({
    ...state,
    brandCode,
  })),
  on(GetTagsSuccess, (state, { res }) => ({
    ...state,
    tagTypeValues: res.payload.data.filter((x: any) => {
      if (x === 'BRAND') return x;
    }),
  })),
  on(ClearTagAssignmentOptions, (state) => ({
    ...state,
    tagType: '',
    brandCode: '',
    searchAvailable: false,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    panelExpanded: true,
    tagType: '',
    brandCode: '',
    searchAvailable: false,
  })),
);
